import { DateRangeValue } from "components/UI/date/DateRange";
import { UnitType } from "constant/dl_unit/unit_type.constant";
import { SEARCH_NAMES, SEARCH_RANGES } from "constant/search/search";

function dateRangeSearchParamsGet(dateRange: DateRangeValue): {
  [key: string]: string;
} {
  const res: { [key: string]: string } = {};
  if (dateRange) {
    if (dateRange.startDate) {
      res[SEARCH_NAMES.DATUM] = dateRange.startDate;
    }
    if (dateRange.endDate) {
      res[SEARCH_NAMES.DATUM_SECOND_RANGE] = dateRange.endDate;
    }
    if (res[SEARCH_NAMES.DATUM] || res[SEARCH_NAMES.DATUM_SECOND_RANGE]) {
      if (!res[SEARCH_NAMES.DATUM_SECOND_RANGE]) {
        res[SEARCH_NAMES.DATUM_RANGE_TYPE] = SEARCH_RANGES.FROM;
      } else if (!res[SEARCH_NAMES.DATUM]) {
        res[SEARCH_NAMES.DATUM_RANGE_TYPE] = SEARCH_RANGES.TO;
      } else {
        res[SEARCH_NAMES.DATUM_RANGE_TYPE] = SEARCH_RANGES.FROM_TO;
      }
    }
  }

  return res;
}

type FormSearchParamsOptions = {
  searchText?: string;
  uType?: string;
  groupSlug?: string;
  dateRange?: DateRangeValue;
  aiSearch?: boolean;
};

export function formSearchParamsGet(
  searchParams: URLSearchParams,
  options: FormSearchParamsOptions = {},
): URLSearchParams {
  const { searchText, uType, groupSlug, dateRange, aiSearch } = options;
  const newSearchParams = new URLSearchParams(searchParams.toString());
  if (searchText) {
    newSearchParams.set(SEARCH_NAMES.SEARCH_TEXT, searchText);
  } else {
    newSearchParams.delete(SEARCH_NAMES.SEARCH_TEXT);
  }
  if (uType) {
    newSearchParams.set(SEARCH_NAMES.U_TYPE, uType);
  } else {
    newSearchParams.delete(SEARCH_NAMES.U_TYPE);
  }
  if (groupSlug) {
    newSearchParams.set(SEARCH_NAMES.GROUP_SLUG, groupSlug);
  } else {
    newSearchParams.delete(SEARCH_NAMES.GROUP_SLUG);
  }

  if (dateRange) {
    const dateRangeValues = dateRangeSearchParamsGet(dateRange);

    for (const [rangeKey, rangeValue] of Object.entries(dateRangeValues)) {
      if (rangeValue) {
        newSearchParams.set(rangeKey, rangeValue);
      } else {
        newSearchParams.delete(rangeKey);
      }
    }
  }

  if (aiSearch) {
    newSearchParams.set(SEARCH_NAMES.AI_SEARCH, `${aiSearch}`);
  } else {
    newSearchParams.delete(SEARCH_NAMES.AI_SEARCH);
  }

  return newSearchParams;
}
